import _slicedToArray from "E:/myprogram/52haoma_new/new-haoma52/haoma52-index/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "E:/myprogram/52haoma_new/new-haoma52/haoma52-index/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.concat.js";
import { unicomAddress } from "@/assets/js/unicom_address";
import isIdcard from "@/assets/js/idcard";
import { showDialog } from "vant";
export default {
  name: 'MainIndex',
  components: {},
  data: function data() {
    return {
      unicomAddressAuto: unicomAddress,
      addressCast: '',
      broadbandProductList: [],
      queryObj: {},
      ascriptionShow: false,
      optShow: false,
      areaCode: [],
      ascription: [],
      addressCascaderValue: [],
      unicomAddress: unicomAddress,
      show: false,
      addressShow: false,
      broadbandOrder: {
        userInfo: {},
        payFlag: 0
      },
      opts: [{
        text: '全部',
        value: null
      }, {
        text: '中国移动',
        value: 1
      }, {
        text: '中国联通',
        value: 2
      }, {
        text: '中国电信',
        value: 3
      }, {
        text: '中国广电',
        value: 5
      }],
      optName: '运营商',
      cityKeyword: '',
      locating: false,
      ipLocationTip: '',
      ipLocationCity: null,
      selectedProduct: {},
      areaStr: '',
      checked: false,
      infoAdvise: false,
      submitBtnFlag: false
    };
  },
  computed: {
    // 手工输入城市名称的搜索结果
    matchedCityList: function matchedCityList() {
      var _this = this;

      var keyword = (this.cityKeyword || '').trim();

      if (!keyword) {
        return [];
      }

      var list = [];
      this.ascription.forEach(function (p) {
        (p.children || []).forEach(function (c) {
          var hitProvince = _this.cityNameMatch(keyword, p.text);

          var hitCity = _this.cityNameMatch(keyword, c.text);

          if (!hitProvince && !hitCity) {
            return;
          }

          list.push({
            province: p.text,
            city: c.text,
            provinceCode: p.value,
            cityCode: c.value,
            both: hitProvince && hitCity ? 1 : 0
          });
        });
      }); // 同时命中省和市的结果排在最前面

      list.sort(function (a, b) {
        return b.both - a.both;
      });
      return list.slice(0, 50);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // 初始化产品列表
    this.initBroadbandProducts(); // 归属地数据加载完成后再做一次静默 IP 定位，便于提示用户切换城市

    this.initAscription().then(function () {
      _this2.locateByIp(true);
    }).catch(function () {});
  },
  methods: {
    // IP 定位到当前所在城市
    locateByIp: function locateByIp(silent) {
      var _this3 = this;

      if (this.locating) {
        return;
      }

      this.locating = true;
      this.requestIpLocation().then(function (location) {
        _this3.locating = false;

        _this3.handleIpLocation(location, silent);
      }).catch(function () {
        _this3.locating = false;

        if (!silent) {
          showDialog({
            message: '定位失败，请手动选择城市'
          });
        }
      });
    },
    // 优先使用服务端 IP 定位，服务端不可用时降级使用第三方 IP 库
    requestIpLocation: function requestIpLocation() {
      var _this4 = this;

      return this.requestServerIpLocation().catch(function () {
        return _this4.requestThirdIpLocation();
      });
    },
    // 服务端 IP 定位：约定接口 GET /ad-server/broadband/ip-location
    // 返回格式：{status: '0000', data: {province: '浙江省', city: '杭州市'}}
    requestServerIpLocation: function requestServerIpLocation() {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/ad-server/broadband/ip-location', true);
        xhr.timeout = 8000;

        xhr.onload = function () {
          var json = null;

          try {
            json = JSON.parse(xhr.responseText);
          } catch (e) {
            json = null;
          }

          var data = json && json.data ? json.data : null;

          if (json && json.status == '0000' && data && data.city) {
            resolve({
              province: data.province,
              city: data.city
            });
          } else {
            reject(new Error('server ip location unavailable'));
          }
        };

        xhr.onerror = function () {
          return reject(new Error('network error'));
        };

        xhr.ontimeout = function () {
          return reject(new Error('timeout'));
        };

        xhr.send();
      });
    },
    // 第三方 IP 库兜底：返回 “浙江省杭州市” 形式的归属地名称
    requestThirdIpLocation: function requestThirdIpLocation() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var timer = null;

        var clean = function clean() {
          clearTimeout(timer);

          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }
        };

        timer = setTimeout(function () {
          clean();
          reject(new Error('timeout'));
        }, 8000);
        script.src = 'https://pv.sohu.com/cityjson?ie=utf-8';

        script.onload = function () {
          clean();
          var data = window.returnCitySN || {};

          if (data.cname && data.cname != '未知') {
            var location = _this5.splitLocationName(data.cname);

            if (location.city) {
              resolve(location);
              return;
            }
          }

          reject(new Error('empty location'));
        };

        script.onerror = function () {
          clean();
          reject(new Error('script error'));
        };

        document.body.appendChild(script);
      });
    },
    // “浙江省杭州市” → {province: '浙江省', city: '杭州市'}
    splitLocationName: function splitLocationName(locationName) {
      var name = (locationName || '').trim();
      var result = {
        province: null,
        city: null
      };
      this.ascription.some(function (p) {
        if (name.indexOf(p.text) == 0) {
          result.province = p.text;
          result.city = name.substring(p.text.length) || p.text;
          return true;
        }

        return false;
      });

      if (!result.city) {
        result.city = name;
      }

      return result;
    },
    // 处理定位结果
    handleIpLocation: function handleIpLocation(location, silent) {
      var matched = this.findAscription(location.province, location.city);

      if (!matched) {
        if (!silent) {
          showDialog({
            message: '当前定位城市暂未开通宽带业务，请手动选择城市'
          });
        }

        return;
      }

      if (matched.province == this.queryObj.province && matched.city == this.queryObj.city) {
        this.clearIpLocationTip();

        if (!silent) {
          showDialog({
            message: '已定位到当前城市：' + matched.province + matched.city
          });
        }

        return;
      }

      if (silent) {
        // 静默定位不直接切换，只提示用户
        this.ipLocationCity = matched;
        this.ipLocationTip = 'IP 定位到 ' + matched.province + ' ' + matched.city + '，点击切换';
      } else {
        // 用户主动点击定位，直接切换到定位到的城市
        this.ipLocationCity = matched;
        this.changeCity(matched.province, matched.city);
      }
    },
    // 在归属地列表中查找对应的省 / 市
    findAscription: function findAscription(province, city) {
      var _this6 = this;

      var result = null;
      this.ascription.forEach(function (p) {
        if (result) {
          return;
        }

        if (province && !_this6.cityNameMatch(province, p.text)) {
          return;
        }

        var cityNode = null;
        (p.children || []).forEach(function (c) {
          if (!cityNode && _this6.cityNameMatch(city, c.text)) {
            cityNode = c;
          }
        });

        if (cityNode) {
          result = {
            province: p.text,
            city: cityNode.text,
            provinceCode: p.value,
            cityCode: cityNode.value
          };
        }
      });
      return result;
    },
    // 切换到 IP 定位到的城市
    switchToLocatedCity: function switchToLocatedCity() {
      if (this.ipLocationCity) {
        this.changeCity(this.ipLocationCity.province, this.ipLocationCity.city);
      }

      this.clearIpLocationTip();
    },
    clearIpLocationTip: function clearIpLocationTip() {
      this.ipLocationTip = '';
    },
    // 判断输入的关键词是否命中省 / 市名称，支持省略“省、市、自治区”等行政后缀
    cityNameMatch: function cityNameMatch(keyword, name) {
      if (!keyword || !name) {
        return false;
      }

      if (keyword.indexOf(name) != -1 || name.indexOf(keyword) != -1) {
        return true;
      }

      var shortName = name.replace(/(特别行政区|自治区|自治州|地区|盟|林区|省|市|县)$/, '');
      return shortName.length >= 2 && keyword.indexOf(shortName) != -1;
    },
    // 输入城市名称后按回车 / 搜索键，取第一条结果
    confirmCityKeyword: function confirmCityKeyword() {
      if (this.matchedCityList.length > 0) {
        this.selectCity(this.matchedCityList[0]);
      }
    },
    // 选中手工搜索出来的城市
    selectCity: function selectCity(item) {
      this.areaCode = [item.provinceCode, item.cityCode];
      this.cityKeyword = '';
      this.changeCity(item.province, item.city);
    },
    // 切换归属地城市
    changeCity: function changeCity(province, city) {
      // 如果归属地修改了 则需要清空掉安装地址
      if (this.queryObj.city != city) {
        this.clearInstallAddress();
      }

      this.queryObj.province = province;
      this.queryObj.city = city;
      this.initAddress();
      this.initBroadbandProducts();
      this.ascriptionShow = false;
      this.clearIpLocationTip();
    },
    chgInfo: function chgInfo() {
      // 假设输入的格式为：电话 姓名 身份证号 地址
      var input = this.addressCast.trim(); // 获取输入内容并去除首尾空格

      var parts = input.split(/\s+/); // 按空格分割字符串

      for (var i = 0; i < parts.length; i++) {
        var item = parts[i].trim();

        if (item.match(/^1\d{10}$/)) {
          this.broadbandOrder.userInfo.phone = item;
        } else if (item.match(/^\d{17}[\dxX]$/)) {
          this.broadbandOrder.userInfo.idCard = item;
        } else if (item.match(/^[\u4e00-\u9fa5]{2,4}$/)) {
          this.broadbandOrder.userInfo.userName = item;
        } else if (item.indexOf("省") != -1 || item.indexOf("市") != -1 || item.indexOf("区") != -1 || item.indexOf("县") != -1) {
          // 处理省市区下拉框
          this.handleAddressFromInput(item);
        }
      }
    },
    // 处理地址下拉框
    handleAddressFromInput: function handleAddressFromInput(address) {
      a: for (var i = 0; i < this.unicomAddressAuto.length; i++) {
        var cities = this.unicomAddressAuto[i].children;

        for (var j = 0; j < cities.length; j++) {
          var areas = cities[j].children;

          for (var k = 0; k < areas.length; k++) {
            var areaName = areas[k].text;
            var index = address.indexOf(areaName);

            if (index != -1) {
              var area = areas[k].text;
              index = index + area.length;
              var detail = address.substr(index);
              var city = cities[j].text;
              var province = this.unicomAddressAuto[i].text;

              if (address.indexOf(province) == -1) {
                continue;
              }

              if (address.indexOf(city) == -1 && address.indexOf("市") != -1) {
                continue;
              }

              this.areaStr = [province, city, area].join('/');
              this.handleAddressChange([province, city, area]);
              this.broadbandOrder.userInfo.address = detail;
              break a;
            }
          }
        }
      }
    },
    // 修改收件地址 省 市 区
    handleAddressChange: function handleAddressChange(options) {
      console.log(options);

      if (options) {
        this.broadbandOrder.userInfo.province = options[0];
        this.broadbandOrder.userInfo.city = options[1];
        this.broadbandOrder.userInfo.area = options[2];
      } else {
        this.broadbandOrder.userInfo.province = null;
        this.broadbandOrder.userInfo.city = null;
        this.broadbandOrder.userInfo.area = null;
      }
    },
    // 提交预约订单
    submitBookingOrder: function submitBookingOrder() {
      var _this7 = this;

      //不可重复点击
      this.submitBtnFlag = true; // 将当前请求的地址进行编码后传入到服务端

      this.broadbandOrder.pageUrl = encodeURIComponent(window.location.href);
      this.broadbandOrder.customerName = window.$customerName; // 获取URL参数

      var urlParams = new URLSearchParams(window.location.search); // 遍历参数列表

      var _iterator = _createForOfIteratorHelper(urlParams),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var param = _step.value;

          var _param = _slicedToArray(param, 2),
              key = _param[0],
              value = _param[1]; // 判断参数是否存在于指定列表中


          if (['callback', 'landingid', 'gdt_vid', 'clickid', 'clickId', 'click_id', 'qz_gdt'].includes(key)) {
            this.orderObj.clickid = value;
            break; // 找到一个有值的参数后即跳出循环
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.broadbandOrder.configId = this.selectedProduct.id;
      this.broadbandOrder.skipValidateMsg = true;
      var url = '/ad-server/broadband/booking-order';
      this.$axios.post(url, this.broadbandOrder).then(function () {
        showDialog({
          message: '预约成功，请注意接听客服来电！'
        });
        _this7.broadbandOrder = {
          userInfo: {}
        };
        _this7.submitBtnFlag = false;
      });
    },
    // 验证身份证号码的合法性
    idCardValidator: function idCardValidator(val) {
      var r = isIdcard(val);

      if (!r) {
        return "身份证号码不合法，请填写正确的身份证号码";
      }
    },
    // 验证联系电话的合法性
    phoneValidator: function phoneValidator(val) {
      if (!/^1[3456789]\d{9}$/.test(val)) {
        return "请填写正确的联系电话";
      }
    },
    // 验证姓名的合法性
    nameValidator: function nameValidator(val) {
      if (!/^[\u4e00-\u9fa5·]{2,16}$/.test(val)) {
        return "请填写正确的开户人姓名";
      }
    },
    bookInstall: function bookInstall(item) {
      // console.log(item);
      this.selectedProduct = item;
      this.show = true;

      if (item.id == -1) {
        this.unicomAddress = unicomAddress;
      } else {
        this.initAddress();
      }
    },
    // 加载宽带产品
    initBroadbandProducts: function initBroadbandProducts() {
      var _this8 = this;

      var url = '/ad-server/broadband/product-list';
      return this.$axios.post(url, this.queryObj).then(function (resp) {
        _this8.broadbandProductList = _this8.sortBroadbandProducts(resp.data.list);
        _this8.queryObj = resp.data.data;

        _this8.initAddress();
      });
    },
    // 产品排序：单宽带按带宽从小到大，融合套餐按带宽从小到大排在最后
    sortBroadbandProducts: function sortBroadbandProducts(list) {
      var _this9 = this;

      if (!list || list.length == 0) {
        return list;
      }

      var normal = [];
      var fusion = [];
      list.forEach(function (item) {
        if (_this9.isFusionProduct(item)) {
          fusion.push(item);
        } else {
          normal.push(item);
        }
      });
      normal.sort(function (a, b) {
        return _this9.parseNumber(a.bandwidth) - _this9.parseNumber(b.bandwidth);
      });
      fusion.sort(function (a, b) {
        return _this9.parseNumber(a.bandwidth) - _this9.parseNumber(b.bandwidth);
      });
      return normal.concat(fusion);
    },
    // 后端没有单独的套餐类型字段，融合套餐的名称中都带有“融合”二字
    isFusionProduct: function isFusionProduct(item) {
      var name = item && item.productName ? item.productName : '';
      return name.indexOf('融合') != -1;
    },
    parseNumber: function parseNumber(val) {
      var num = parseFloat(val);
      return isNaN(num) ? 0 : num;
    },
    // 初始化宽带产品的归属地列表
    initAscription: function initAscription() {
      var _this10 = this;

      var url = '/ad-server/broadband/ascription-list';
      return this.$axios.post(url, this.queryObj).then(function (resp) {
        _this10.ascription = resp.data.list;
      });
    },
    initAddress: function initAddress() {
      var province = this.queryObj.province;
      var city = this.queryObj.city;
      var provinceCode = null;
      var cityCode = null;
      this.ascription.forEach(function (p) {
        if (p.text == province) {
          provinceCode = p.value;
          p.children.forEach(function (c) {
            if (c.text == city) {
              cityCode = c.value;
              return true;
            }
          });
          return true;
        }
      });
      this.areaCode = [provinceCode, cityCode]; // 初始化安装地址，宽带只能本地装本地

      var address = this.findAddressNode(province, city);

      if (address) {
        this.unicomAddress = [address];
      } else {
        // 地址库中没有对应的城市时，放开让用户自行选择
        this.unicomAddress = unicomAddress;
      } // console.log(this.unicomAddress);

    },
    // 在地址库中查找省 / 市节点，兼容“哈尔滨”、“攀枝花”这类不带行政后缀的写法
    findAddressNode: function findAddressNode(province, city) {
      var _this11 = this;

      var node = null;
      unicomAddress.forEach(function (p) {
        if (node) {
          return;
        }

        if (!_this11.cityNameMatch(province, p.text)) {
          return;
        }

        var matchedCity = null;
        (p.children || []).forEach(function (c) {
          if (!matchedCity && _this11.cityNameMatch(city, c.text)) {
            matchedCity = c;
          }
        });

        if (matchedCity) {
          node = {
            text: p.text,
            value: p.value,
            children: [matchedCity]
          };
        }
      });
      return node;
    },
    // 确定定位的城市
    confirmAscription: function confirmAscription(options) {
      // console.log(options);
      var selectedOptions = options.selectedOptions;
      this.changeCity(selectedOptions[0].text, selectedOptions[1].text);
    },
    confirmAddress: function confirmAddress(options) {
      var selectedOptions = options.selectedOptions;
      var province = selectedOptions[0].text;
      var city = selectedOptions[1].text;
      var area = selectedOptions[2].text;
      this.areaStr = province + ' / ' + city + ' / ' + area;
      this.broadbandOrder.userInfo.province = province;
      this.broadbandOrder.userInfo.city = city;
      this.broadbandOrder.userInfo.area = area;
      this.addressShow = false;
    },
    confirmOpt: function confirmOpt(options) {
      var selectedOptions = options.selectedOptions;
      this.optName = selectedOptions[0].text;
      this.queryObj.productOptId = selectedOptions[0].value;
      this.initBroadbandProducts();
      this.optShow = false;
    },
    // 清除安装地址
    clearInstallAddress: function clearInstallAddress() {
      this.areaStr = '';
      this.broadbandOrder.userInfo.province = null;
      this.broadbandOrder.userInfo.city = null;
      this.broadbandOrder.userInfo.area = null;
    }
  }
};